import { useCurrentProject } from "@radarly/core/project/use-cases";

export function useMilestones() {
  return useCurrentProject()?.milestones;
}
